export enum MessageTypes {
  REQUEST = 'request',
  RESPONSE = 'response',
  MESSAGE = 'message',
  CONFIRM = 'confirm',
  NOTIFICATION = 'notification',
  ACKNOWLEDGE = 'acknowledge'
}
